import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';

const TOOLTIP_MESSAGE =
  'On selecting this checkbox, the message "Your trust balance is sufficient/insufficient to cover this invoice." will not be displayed to the client.';
const SuppressTrustBalanceMessageV2 = ({ checked, onChange, disabled }) => {
  return (
    <div className="mt-4 col-12">
      <div className="col-12 d-flex align-items-center mb-2 flex-nowrap">
        <span className="mb-0 pe-4 d-inline-flex align-items-center flex-shrink-0 gap-0">
          <label htmlFor="suppressTrustBalanceMessage" className="caption-bold mb-0 pe-4">
            Suppress Trust Balance Message
          </label>
          <i
            className="pi pi-info-circle text-muted cursor-pointer suppress-trust-balance-msg-tip flex-shrink-0 align-middle"
            style={{ fontSize: '12px', lineHeight: 1, padding: '5px' }}
            aria-label="More information"
            role="img"
          />
        </span>
        <span className="d-inline-flex align-items-center justify-content-center flex-shrink-0" style={{ height: 24 }}>
          <Checkbox
            inputId="suppressTrustBalanceMessage"
            checked={!!checked}
            onChange={(e) => onChange?.(e.checked)}
            disabled={disabled}
            className="m-0 p-0"
          />
        </span>
      </div>
      <Tooltip target=".suppress-trust-balance-msg-tip" content={TOOLTIP_MESSAGE} position="top" showDelay={300} />
    </div>
  );
};

export default SuppressTrustBalanceMessageV2;
